import React, { useEffect, useState } from "react";

import { calculateTickByMacroScore, macroScoreColors } from "../../utils/ticks";
import ScoreCircularProgress from "../ScoreCircularProgress";
import Gauge from "./Gauge";
import * as SC from "./ScoreGauge.styles";

type ScoreGaugeProps = {
  score?: number | null;
  size?: number;
  updatedAt?: number;
  showGrade?: boolean;
  onPreview?: () => void;
};

const ScoreGauge = ({
  score,
  size = 140,
  updatedAt,
  showGrade,
  onPreview,
}: ScoreGaugeProps) => {
  const [circleColor, setCircleColor] = useState<string>();
  const [tick, setTick] = useState<number>(0);

  useEffect(() => {
    const finalScore =
      score === null || score?.toString() === "0"
        ? localStorage.getItem("score")
        : score;
    if (!finalScore) return;
    const tickValue = calculateTickByMacroScore(+finalScore);
    setTick(tickValue);
    const colors = macroScoreColors;
    setCircleColor(colors[tickValue - 1] || macroScoreColors[0]);
  }, [score]);

  const grade = "FEDCBA"[tick];
  const fallback =
    (navigator.userAgent.includes("Safari") &&
      !navigator.userAgent.includes("Chrome")) ||
    (/Safari/.test(navigator.userAgent) &&
      /Apple Computer/.test(navigator.vendor));

  return (
    <SC.WrapperHover size={size} showGrade={showGrade}>
      <SC.Wrapper showGrade={showGrade}>
        <SC.Container>
          {fallback ? (
            <ScoreCircularProgress
              score={score!}
              width="140px"
              height="140px"
              strokeWidth={8}
            />
          ) : (
            <>
              <Gauge
                size={size}
                score={score}
                grade={grade}
                gradeColor={circleColor}
              />
            </>
          )}
          {updatedAt && (
            <SC.DateChip>
              {new Intl.DateTimeFormat("en-uk", { dateStyle: "medium" })
                .format(new Date(updatedAt))
                .replace(" 20", " ")}
            </SC.DateChip>
          )}
        </SC.Container>
      </SC.Wrapper>
    </SC.WrapperHover>
  );
};

export default ScoreGauge;
